import "./Highlights.css"
import ImageBox from "../ImageBox/ImageBox";

export default function Highlights() {
  return (
    <div className="section highlights">
      <h2>Eindrücke</h2>
      <p>Hier einige Eindrücke aus unserem Laden..</p>
      <ImageBox />
    </div>
  );
}
